module.exports = "/_next/static/images/UseAi-f9b32d9f75595a0bb2e9f0d528bc4ed8.webp";